import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';

/**
 * Gets the fallback value for week start day option in calendar appearance settings
 */
export default () => {
    let calendarConfiguration = getCalendarConfiguration();
    return getFallbackValueIfNull(
        store().weekStartDay,
        calendarConfiguration && calendarConfiguration.WeekStartDay
    );
};
